import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';
import ListeDeroulante from '../../UI/ListeDeroulante/ListeDeroulante';

import S from './NumberInput.module.scss';

const NumberInput = ({ argument, onChange }) => {
  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  const numberTypes = [
    { value: 'integer', label: 'Nombre entier' },
    { value: 'float', label: 'Nombre décimal' },
    { value: 'percentage', label: 'Pourcentage (0-100)' },
  ];

  return (
    <div className={S.numberContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet la saisie de valeurs numériques avec
          validation.
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            value={argument.description || ''}
            onChange={(value) => onChange('description', value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Valeur par défaut</label>
          <ChampDeTexte
            type="number"
            value={argument.valeurParDefaut || ''}
            onChange={(value) => onChange('valeurParDefaut', value)}
            placeholder="Valeur par défaut"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            onChange={(checked) => onChange('obligatoire', checked)}
            label="Argument obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options spécifiques</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Type de nombre</label>
          <ListeDeroulante
            value={argument.options?.numberType || 'float'}
            onChange={(value) => handleOptionChange('numberType', value)}
            options={numberTypes}
          />
        </div>

        <div className={S.gridTwo}>
          <div className={S.champGroupe}>
            <label className={S.label}>Valeur minimum</label>
            <ChampDeTexte
              type="number"
              value={argument.options?.min || ''}
              onChange={(value) =>
                handleOptionChange('min', parseFloat(value) || null)
              }
              placeholder="Pas de minimum"
            />
          </div>

          <div className={S.champGroupe}>
            <label className={S.label}>Valeur maximum</label>
            <ChampDeTexte
              type="number"
              value={argument.options?.max || ''}
              onChange={(value) =>
                handleOptionChange('max', parseFloat(value) || null)
              }
              placeholder="Pas de maximum"
            />
          </div>
        </div>

        <div className={S.gridTwo}>
          <div className={S.champGroupe}>
            <label className={S.label}>Pas d'incrémentation</label>
            <ChampDeTexte
              type="number"
              value={argument.options?.step || ''}
              onChange={(value) =>
                handleOptionChange('step', parseFloat(value) || null)
              }
              placeholder="1"
              min="0"
              step="0.01"
            />
          </div>

          <div className={S.champGroupe}>
            <label className={S.label}>Nombre de décimales</label>
            <ChampDeTexte
              type="number"
              value={argument.options?.decimals || ''}
              onChange={(value) =>
                handleOptionChange('decimals', parseInt(value) || null)
              }
              placeholder="Auto"
              min="0"
              max="10"
            />
          </div>
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Unité</label>
          <ChampDeTexte
            value={argument.options?.unit || ''}
            onChange={(value) => handleOptionChange('unit', value)}
            placeholder="Ex: °C, km/h, %"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.allowNegative !== false}
            onChange={(checked) => handleOptionChange('allowNegative', checked)}
            label="Permettre les valeurs négatives"
          />
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              Nombre {argument.options?.numberType || 'décimal'}
              {argument.options?.unit && ` (${argument.options.unit})`}
              {(argument.options?.min !== null ||
                argument.options?.max !== null) && (
                <div className={S.mockRange}>
                  Range: {argument.options?.min || '∞'} -{' '}
                  {argument.options?.max || '∞'}
                </div>
              )}
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumberInput;
